import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import toast from 'react-hot-toast';
import cn from 'classnames';

import { 
  getAllergies, 
  deleteAllergy, 
  importAllergies,
  addAllergyIngredient,
  deleteAllergyIngredient,
 } from '../../actions/allergy';
import { getIngredients } from '../../actions/ingredient';
import AllergiesModal from '../../components/AllergiesModal/AllergiesModal';
import ImportButton from '../../components/ImportButton/ImportButton';
import styles from './Allergies.module.css';

const Allergies = (props) => {
  const { 
    getAllergies, 
    getIngredients,
    allergiesData,
    deleteAllergy,
    addAllergyIngredient,
    deleteAllergyIngredient,
    importAllergies,
    ingredientsData,
   } = props;
   console.log('===ingredientsData', ingredientsData);

  const [showModal, setShowModal] = useState(false);
  const [initialValue, setInitialValue] = useState(null);
  const [addIngredientId, setAddIngredientId] = useState(null);
  const [selectedIngredient, setSelectedIngredient] = useState('');

  useEffect(() => {
    getAllergies();
    getIngredients();
  }, []);

  const openModalHandler = () => {
    setInitialValue(null);
    setShowModal(true);
  };

  const editHandler = (allergyData) => {
    setInitialValue(allergyData);
    setShowModal(true);
  };

  const onImportAllergies = (file) => {
    importAllergies({ csv: file }, () => {
      toast.success('Success', {
        position: 'bottom-right',
        duration: 3000,
      });
    });
  };

  const deleteHandler = (id) => {
    const confirmResult = window.confirm('Are you sure?');

    if (confirmResult) {
      deleteAllergy(id);
    }
  };

  const addIngredient = () => {
    if (!selectedIngredient) {
      return toast.error('You must select ingredient', {
        position: 'bottom-right',
        duration: 3000,
      });
    }

    const ingredientData = {
      allergy_id: addIngredientId,
      ingredient_id: selectedIngredient,
    };

    addAllergyIngredient(ingredientData, () => {
      setAddIngredientId(null);
      setSelectedIngredient('');
      toast.success('Success', {
        position: 'bottom-right',
        duration: 3000,
      });
    });

    console.log('===INGREDIENT ID', selectedIngredient);
  };

  const deleteIngredient = (allergyId, ingredientId) => {
    const confirmResult = window.confirm('Are you sure?');

    if (!confirmResult) {
      return;
    }

    const ingredientData = {
      allergy_id: allergyId,
      ingredient_id: ingredientId,
    };

    deleteAllergyIngredient(ingredientData, () => {
      toast.success('Success', {
        position: 'bottom-right',
        duration: 3000,
      });
    });

    console.log('===DELETE', allergyId, ingredientId);
  };

  const renderAddIngredientButton = (allergyId) => {
    if (allergyId === addIngredientId) {
      return (
        <div className={styles.selectWrapper}>
          <select 
            className={styles.select}
            value={selectedIngredient}
            onChange={({ target }) => {
              setSelectedIngredient(target.value);
            }}
          >
            <option value="" disabled >Select ingredient</option>
            {ingredientsData?.map((ingredient) => (
              <option
                key={ingredient.id} 
                value={ingredient.id}
              >
                {ingredient.name} ({ingredient.unit_type})
              </option>
            ))}
          </select>
          <div 
            className={styles.selectButton}
            onClick={addIngredient}
          >
            +
          </div>
        </div>
      );
    }

    return (
      <button 
        className="button yellow-button" 
        onClick={() => setAddIngredientId(allergyId)}
      >
        Add Ingredient
      </button>
    );
  };

  return (
    <div className="wrapper">
      <AllergiesModal 
        key={initialValue?.id}
        isOpen={showModal} 
        onClose={() => setShowModal(false)}
        initialValue={initialValue}
      />
      <div className={styles.tools}>
        <h1>
          Allergies
        </h1>
        <div className={styles.buttons}>
          <ImportButton 
            className={styles.importButton}
            onImport={onImportAllergies}
          >
            CSV import
          </ImportButton>
          <div className={styles.addDish} onClick={openModalHandler}>
            Add allergy
          </div>
        </div>
      </div>
      <table className={cn(styles.table, 'table')}>
        <thead>
        <tr>
          <th>Id</th>
          <th>Name</th>
          <th>Ingredients</th>
          <th>Controls</th>
        </tr>
        </thead>
        <tbody>
        {allergiesData?.map((allergyItem) => (
          <tr key={allergyItem.id}>
            <td>
              {allergyItem.id}
            </td>
            <td>
              {allergyItem.name}
            </td>
            <td>
              {allergyItem.ingredients?.map((ingredient) => (
                <div className={styles.ingredient} key={ingredient.id}>
                  {ingredient.name} ({ingredient.unit_type})
                  <div 
                    className={styles.deleteIngredient}
                    onClick={() => deleteIngredient(allergyItem.id, ingredient.id)}
                  >
                    ×
                  </div>
                </div>
              ))}
            </td>
            <td className="controls">
              <button className="button green-button" onClick={() => editHandler(allergyItem)}>
                Edit
              </button>
              <button className="button red-button" onClick={() => deleteHandler(allergyItem.id)}>
                Delete
              </button>
              {renderAddIngredientButton(allergyItem.id)}
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (store) => ({
  allergiesData: store.allergy.allergiesData,
  ingredientsData: store.ingredient.ingredientsData,
});

const mapDispatchToProps = {
  getAllergies, 
  getIngredients,
  deleteAllergy,
  importAllergies,
  addAllergyIngredient,
  deleteAllergyIngredient,
};

export default connect(mapStateToProps, mapDispatchToProps)(Allergies);